import { IParameterCondition } from '@/pages/Dashboards/Charts/SVGChart/svgChart.types.ts'
import { IOption } from '@/types/global.ts'
import DropdownInput from '@/shared/Inputs/DropdownInput'

interface IProps {
  title: string
  value: IParameterCondition['condition']
  onChange: (value: IParameterCondition['condition'], name: string) => void
  name: string
}

const options: IOption<IParameterCondition['condition']>[] = [
  { value: '<', title: '<' },
  { value: '<=', title: '<=' },
  { value: '=', title: '=' },
  { value: '>', title: '>' },
  { value: '>=', title: '>=' },
]

const SVGSettingsConditionDropdown = (props: IProps) => {
  return (
    <DropdownInput
      title={props.title}
      options={options}
      onSelect={props.onChange}
      selectedOption={props.value as any}
      name={props.name}
    />
  )
}

export default SVGSettingsConditionDropdown
